import API from "../api/manager";
import config from "../api/config";

const createMeetingUrlArb = (data) => {
  return API({
    method: "POST",
    url: config.urls.meeting.createMeetingUrlArb,
    data,
  });
};

const getMeetingUrlArb = (query) => {
  return API({
    method: "GET",
    url: config.urls.meeting.getMeetingUrlArb + query,
  });
};

const meetingRecordingDetArb = (id) => {
  return API({
    method: "GET",
    url: config.urls.meeting.meetingRecordingDetArb + id,
  });
};

const arbitratorJoinMeeting = (data, code) => {
  return API(
    {
      method: "POST",
      url: `${config.urls.meeting.arbitratorJoinMeeting}/${code}`,
      data,
    },
    false,
  );
};

const joinMeeting = (meetingId) => {
  return API({
    method: "GET",
    url: `${config.urls.meeting.joinMeetingUrlArb}/${meetingId}`,
  });
};

const deleteMeetingLink = (data) => {
  return API({
    method: "DELETE",
    url: config.urls.meeting.deteleMeetingLink,
    data,
  });
};

const communicationTemplates = (query) => {
  return API({
    method: "GET",
    url: config.urls.meeting.communicationTemplates + query,
  });
};

const postCommunication = (data) => {
  return API({
    method: "POST",
    url: config.urls.meeting.communicationTemplates,
    data,
  });
};

export default {
  createMeetingUrlArb,
  getMeetingUrlArb,
  meetingRecordingDetArb,
  arbitratorJoinMeeting,
  joinMeeting,
  deleteMeetingLink,
  communicationTemplates,
  postCommunication,
};
